export default `
@import url('https://fonts.googleapis.com/css?family=Raleway:400,700|Trocchi|Ultra&display=swap');
`



// WEBPACK FOOTER //
// ./src/ui/styles/fonts.js